// Please put date in YYYY-MM-DD format
export const stuysquadPhotos = [
    {
        name: "StuySquad 2020 Dinner",
        desc: "Dinner at WokWok. We completely filled up the place.",
        date: "2020-01-04",
    	imgname: "dinner_2020-0.png",
    	credits: "Nice WokWok worker",
    },
    {
        name: "StuySquad 2020 Dinner",
        desc: "Dinner at WokWok. We completely filled up the place.",
        date: "2020-01-04",
    	imgname: "dinner_2020-1.png",
    	credits: "Nice WokWok worker",
    },
    {
        name: "StuySquad 2020 Studio",
        desc: "Pointing at the mirror. Wow look at us so cool.",
        date: "2020-01-13",
    	imgname: "studio_2020-0.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020 Crew Pic",
        desc: "Crowded all 130 of us into one picture. Aaron looks so small.",
        date: "2020-01-20",
    	imgname: "stuysquad_2020-0.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020 Crew Pic",
        desc: "Crowded all 130 of us into one picture.",
        date: "2020-01-27",
    	imgname: "stuysquad_2020-1.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2018",
        desc: "Exposure of the Symphony piece.",
        date: "2018-01-24",
    	imgname: "stuysquad-2018-0.png",
    	credits: "yeet",
    },
    {
        name: "StuySquad 2019 Crew Pic",
        desc: "Post show first atrium picture!",
        date: "2019-01-24",
    	imgname: "stuysquad-2019-0.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020 Flow Omega",
        desc: "Flow Omega, the Disney crew!",
        date: "2020-01-27",
    	imgname: "flow_omega.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020 Flow Kappa",
        desc: "Flow Kappa, the ATLA crew!",
        date: "2020-01-27",
    	imgname: "flow_kappa.png",
    	credits: "Khandy",
    },
    {
        name: "Khandy's Avatar Hat",
        desc: "Very creative.",
        date: "2020-01-27",
    	imgname: "stuysquad-2020-avatar.png",
    	credits: "Khandy",
    },
    {
        name: "StuySquad 2020 Ninja",
        desc: "Ninja bonding game! RIP Chloe.",
        date: "2019-11-26",
    	imgname: "stuysquad-2020-ninja.png",
    	credits: "yeet",
    },
    

]
